'use strict';

import React, { Component } from 'react'

import Layout from '@Layout/BackOffice'

import Dashboard from '@/Lists/Dashboard'
import SynerQuizzRow     from '@/Lists/Rows/SynerQuizzRow'

import config from '@Config/SynerQuizz/syner_quizz'

import SearchBar from '@Pure/SearchBar'
import Link      from '@Pure/Link'

let app = window.app;

const header = Object.keys(config.header_map).map(function (label)
{
	const name = config.header_map[label];

	const item =
	{
		label: label,
		name: name,
		sortable: (config.sortable_columns || []).includes(name)
	};

	return item;
});

const fields = header.map(data => data.name);

const fields_with_timeout = ['searched'];

export default class SynerQuizzDashboardPage extends Component
{
	state =
	{
		searched: window.localStorage.getItem('SynerQuizzList.searched') || '',

		delayed_searched: window.localStorage
		.getItem('SynerQuizzList.searched') || '',

		with_disabled: window.localStorage
		.getItem('SynerQuizzList.with_disabled') || '',

		status_messages: { }
	};

	UNSAFE_componentWillMount ()
	{
		app.resetFunctions();
	}

	handleSearchChange = (value, data={ }, e) =>
	{
		const component = this, props = this.props, state = this.state;

		component.handleChange({ value: value, name: data?.name, e });
	}

	handleChange = ({ value, name, e }) =>
	{
		const component = this, props = this.props, state = this.state;

		window.localStorage.setItem('SynerQuizzList.' + name, value);

	// Prevent on mount trigger
		if (e === null && fields_with_timeout.includes(name)) return;

		component.setState({ [name]: value });

		if (fields_with_timeout.includes(name) === false) return;

		if (component.search_timeout)
		{
			window.clearTimeout(component.search_timeout);
		}

		component.search_timeout = window.setTimeout(function ()
		{
			component.search_timeout = undefined;

			component.setState({ ['delayed_' + name]: value });
		},
		320);
	}
	render ()
	{
		const component = this, props = this.props, state = this.state;

		const filters =
		{
			searched: state.delayed_searched,

			disabled: [true, 'true'].includes(state.with_disabled)
		};

		var output =
		(
			<Layout history={ props.history } page_title="Liste des Syner'Quizz">

				<div className="page-content">

					<div className="o-grid-4 u-content-between u-items-center
						u-margin-bottom-30">

						<div className="o-grid__item">
							<SearchBar hide_btn={ true } placeholder="Recherche..."
								handleChange={ component.handleSearchChange }
								value={ state.searched }
								name="searched"
							/>
						</div>

						<div className="o-grid__item"></div>

						<div className="o-grid__item u-flex u-content-end
							u-items-center">
							<Link href="/configuration/syner-quizz/nouveau"
								className="c-btn c-btn--add u-no-margin-top">
								{ config.creation_label }
							</Link>
						</div>

					</div>

					<div className="o-content">
						<Dashboard model="SynerQuizz" items-per-page={ 50 }
							url="/dashboard/syner-quizz" filters={ filters }
							header={ header } fields={ fields }
							order="DESC" order-by="start"
							disable-sort={ filters.searched ? true : false }
							component={ SynerQuizzRow }
						/>
					</div>

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;
	}
}
